import { LayoutConst } from 'core';
import styled from 'styled-components';
import { css } from 'styled-components';

export const ImageWrapper = styled.div<{
    isDefaultPlaceholder?: boolean
    isCompetition?: boolean
}>`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ isDefaultPlaceholder, theme, isCompetition }) => 
        isDefaultPlaceholder ? css`
            background-color: ${!isCompetition ? theme.imagePlaceholder.bg : '#464645'};

            svg, stroke, path {
                color: ${theme.imagePlaceholder.icon};
            }
        ` : ""
    }
`;

export const Image = styled.img`
    width: 100%;
    object-fit: cover;
    height: 100%;
`;import { LayoutConst } from 'core';
import styled from 'styled-components';
import { css } from 'styled-components';

export const ImageWrapper = styled.div<{
    isDefaultPlaceholder?: boolean
    isCompetition?: boolean
}>`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ isDefaultPlaceholder, theme, isCompetition }) => 
        isDefaultPlaceholder ? css`
            background-color: ${!isCompetition ? theme.imagePlaceholder.bg : '#464645'};

            svg, stroke, path {
                color: ${theme.imagePlaceholder.icon};
            }
        ` : ""
    }
`;

export const Image = styled.img`
    width: 100%;
    object-fit: cover;
    height: 100%;
`;